// extracted by mini-css-extract-plugin
module.exports = {"bundle-banner":"BundleBanner_bundle-banner__URRi_","bundle-banner-container":"BundleBanner_bundle-banner-container__vBpkW","icon":"BundleBanner_icon__xU8Nh"};